import React, { useEffect, useState } from 'react';

const modernFooterStyles = `
  .footer-modern-section {
    width: 100%;
    background: #03131b;
    color: #94a3b8;
    padding: 1rem 0;
    font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
    font-size: 0.92rem;
    font-weight: 500;
    letter-spacing: 0.01em;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .footer-modern-content {
    width: 100%;
    max-width: 1140px;
    margin: 0 auto;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    gap: 0.5rem;
  }
  .footer-modern-link {
    color: #7ee8fa;
    text-decoration: none;
    font-weight: 600;
    margin-left: 0.3em;
    transition: color 0.18s;
  }
  .footer-modern-link:hover {
    color: #ffffff;
    text-decoration: underline;
  }
  @media (max-width: 600px) {
    .footer-modern-section {
      font-size: 0.85rem;
      padding: 0.8rem 0;
    }
    .footer-modern-content {
      justify-content: center;
      text-align: center;
    }
  }
`;

export default function Footer() {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);

  return (
    <footer className="footer-modern-section">
      <style>{modernFooterStyles}</style>
      <div className="footer-modern-content">
        <span>
          &copy; {currentYear} Flynn - Meagher Library, Vidyajyoti College of Theology. All Rights Reserved.
        </span>
        <span>
          Powered by
          <a
            className="footer-modern-link"
            href="https://idntica.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            idntica.com
          </a>
        </span>
      </div>
    </footer>
  );
}
